import { useTranslation } from 'react-i18next';
import Button from '../../../components/Common/Button/Button';
import ContentApp from '../../../components/ContentApp';
import Header from '../../../components/Common/Header/Header';
import styles from '../reservation.module.css';
import ReservationSent from '../../../components/icons/ReservationSent';
import FixedButton from '../../../components/Common/FixedButton/FixedButton';
import { useSelector } from 'react-redux';
import '../../../css/reservation.css';
import SuccessCheck from '../../../components/icons/SuccessCheck';
import { getQueryString } from '../../../helpers/url';

const ReservationSuccess = ({ history }) => {
  //tipe === 'ticket' && status === 'WAITING_DEPOSIT' 'LINK DE PAGO ENVIADO MAIL/TELEFONO/WSP'
  //tipe === '!ticket' && status === 'CONFIRMED' 'RESERVA CONFIRMADA'
  //tipe === '!ticket' && status === 'PENDING' = 'Solicitud enviada (pantalla actual)'
  //tipe === 'ticket' && status === 'PENDING' = 'Solicitud de compra enviada/Una vez confirmada recibira link de pago (REVISAR)'
  const { t } = useTranslation();
  const showName = useSelector((state) => state.reservation.showName);

  const reservationType = getQueryString('reservationType');
  const status = getQueryString('status');

  const pending = () => {
    return (
      <>
        <div className={`bold text-left font-large ${styles.title}`}>{t('requestSent')}</div>
        <div className='text-secondary semi-bold font-normal text-left mt-3'>
          {t('processingRequest')}
        </div>
      </>
    );
  };

  const waitingDeposit = () => {
    return (
      <>
        <div className={`bold text-left font-large ${styles.title}`}>{t('linkSent')}</div>
        <div className='text-secondary semi-bold font-normal text-left mt-3'>
          {t('messageSent')}
        </div>
      </>
    );
  };

  const reservationConfirmed = () => {
    return (
      <>
        <div className={`bold text-left font-large ${styles.title}`}>
          {t('reservationConfirmed')}
        </div>
        <div className='text-secondary semi-bold font-normal text-left mt-3'>
          {t('reservationWasSuccessfullyConfirmed')}
        </div>
      </>
    );
  };

  const invitation = () => {
    return (
      <>
        <div className={`bold text-left font-large ${styles.title}`}>
          {t('invitationConfirmed')}
        </div>
        <div className='text-secondary semi-bold font-normal text-left mt-3'>
          {t('invitationConfirmedSubtitle')}
        </div>
      </>
    );
  };

  const renderContent = () => {
    if (reservationType === 'INVITATION') {
      return invitation();
    } else if (reservationType && status === 'PENDING') {
      return pending();
    } else if (reservationType !== 'TICKET' && status === 'CONFIRMED') {
      return reservationConfirmed();
    } else if (status === 'WAITING_DEPOSIT') {
      return waitingDeposit();
    }
    return null;
  };

  return (
    <>
      <Header showBack={false} title={showName} />
      <ContentApp classes={'pt-0'}>
        <div className={`d-flex align-items-center justify-content-center ${styles.iconContainer}`}>
          {reservationType !== 'TICKET' && status === 'PENDING' ? (
            <ReservationSent color={'var(--color-primary)'} size='135px' />
          ) : (
            <SuccessCheck color='var(--color-primary)' size={200} />
          )}
        </div>
        <div className='mt-5 pt-3 px-3'>{renderContent()}</div>
        <FixedButton>
          <Button
            text={t('returnHome')}
            size='large'
            className={`mt-2 ${styles.btn}`}
            onClick={() => history.push('/')}
            icon={true}
            typeIcon='arrow'
            iconColor='#000'
          />
        </FixedButton>
      </ContentApp>
    </>
  );
};

export default ReservationSuccess;
